import { useCallback, useState } from 'react';
import { loadSidebarRetraida, saveSidebarRetraida } from './sidebarStorage';

export function useSidebarRetraida() {
  const [retraida, setRetraida] = useState(() => loadSidebarRetraida());

  const toggleRetraida = useCallback(() => {
    setRetraida((prev) => {
      const next = !prev;
      saveSidebarRetraida(next);
      return next;
    });
  }, []);

  return { retraida, toggleRetraida };
}
